import { BasketItem } from '@components/Basket/BasketItem';

import { Product } from './types';

interface ItemProps {
  product: Product;
}

const Item: React.FC<ItemProps> = ({ product }) => {
  if (!product) {
    return null;
  }

  const { type, charges, total, oneTimeCost, afterPromo } = product;

  return (
    <BasketItem
      type={type}
      charges={charges}
      total={total}
      oneTimeCost={oneTimeCost}
      afterPromo={afterPromo}
    />
  );
};

export { Item };
